import type { ReactElement } from 'react';
import { createElement } from 'react';

import { cn } from '#/utils/cn';

import { ArrowDownIcon } from './ArrowDownIcon';
import { ArrowRightIcon } from './ArrowRightIcon';
import { ArrowUpIcon } from './ArrowUpIcon';
import { ChartIcon } from './ChartIcon';
import { CheckIcon } from './CheckIcon';
import { ChevronLeftIcon } from './ChevronLeftIcon';
import { ChevronRightIcon } from './ChevronRightIcon';
import { CloseIcon } from './CloseIcon';
import { DownloadIcon } from './DownloadIcon';
import { ExclamationIcon } from './ExclamationIcon';
import { ExpandIcon } from './ExpandIcon';
import { FolderIcon } from './FolderIcon';
import { InfoIcon } from './InfoIcon';
import { NewspaperIcon } from './NewspaperIcon';
import { OctagonCheckIcon } from './OctagonCheckIcon';
import { PlusIcon } from './PlusIcon';
import { PlusMinusIcon } from './PlusMinusIcon';
import { SearchIcon } from './SearchIcon';
import { TimestampIcon } from './Timestamp';

export { ArrowDownIcon } from './ArrowDownIcon';
export { ArrowRightIcon } from './ArrowRightIcon';
export { ArrowUpIcon } from './ArrowUpIcon';
export { ChartIcon } from './ChartIcon';
export { CheckIcon } from './CheckIcon';
export { ChevronLeftIcon } from './ChevronLeftIcon';
export { ChevronRightIcon } from './ChevronRightIcon';
export { CloseIcon } from './CloseIcon';
export { DownloadIcon } from './DownloadIcon';
export { ExclamationIcon } from './ExclamationIcon';
export { ExpandIcon } from './ExpandIcon';
export { FolderIcon } from './FolderIcon';
export { InfoIcon } from './InfoIcon';
export { NewspaperIcon } from './NewspaperIcon';
export { OctagonCheckIcon } from './OctagonCheckIcon';
export { PlusIcon } from './PlusIcon';
export { PlusMinusIcon } from './PlusMinusIcon';
export { SearchIcon } from './SearchIcon';
export { TimestampIcon } from './Timestamp';

export type IconId =
  | 'arrow-down'
  | 'arrow-right'
  | 'arrow-up'
  | 'chart'
  | 'check'
  | 'chevron-left'
  | 'chevron-right'
  | 'close'
  | 'download'
  | 'exclamation'
  | 'expand'
  | 'folder'
  | 'info'
  | 'newspaper'
  | 'octagon-check'
  | 'plus'
  | 'plus-minus'
  | 'search'
  | 'timestamp';

interface IconComponentProps {
  size?: number | string;
  color?: string;
  className?: string;
}

type IconComponent = (props: IconComponentProps) => ReactElement;

const iconRegistry: Record<IconId, IconComponent> = {
  'arrow-down': ArrowDownIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  chart: ChartIcon,
  check: CheckIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-left': ChevronLeftIcon,
  close: CloseIcon,
  download: DownloadIcon,
  exclamation: ExclamationIcon,
  expand: ExpandIcon,
  folder: FolderIcon,
  info: InfoIcon,
  newspaper: NewspaperIcon,
  'octagon-check': OctagonCheckIcon,
  plus: PlusIcon,
  'plus-minus': PlusMinusIcon,
  search: SearchIcon,
  timestamp: TimestampIcon,
};

export const iconIds = Object.keys(iconRegistry) as IconId[];

interface IconProps extends IconComponentProps {
  id: IconId;
}

export function Icon({ id, className, ...props }: IconProps): ReactElement {
  const IconComponent = iconRegistry[id];

  return createElement(IconComponent, {
    ...props,
    className: cn('shrink-0', className),
  });
}
